module.exports = "/_next/static/images/13916aa81ccbc4a450865e57e217bd1e-card-green-check-icon.svg";